// extracted by mini-css-extract-plugin
export default {"container":"StickyColumn_container__tXJgL","content":"StickyColumn_content__3ynxL","scrollable":"StickyColumn_scrollable__ct2g-"};